<!-- @format -->

<div class="sis-mb-xs">
  <sis-module-box [moduleGroupId]="selection.moduleGroupId" [attainment]="attainment" [categoryCssClass]="moduleColorCategory">
    <div module-box="extraitemholder">
      @if (editMode) {
        <div class="additional-box">
          <sis-button class="button-box" [link]="true" (clicked)="removeModule.emit()" [ariaLabel]="'ARIA_LABEL.DELETE' | translate">
            <sis-icon icon="delete"></sis-icon>
          </sis-button>
        </div>
      }
    </div>
    <div module-box="notifications">
      @if (isApprovedMinorSelection && (this.editMode || !this.attainment) && selection.validityPeriod) {
        <div class="studymodule-notification-bar">
          <div class="studymodule-notification">
            <ng-container
              [ngTemplateOutlet]="notification"
              [ngTemplateOutletContext]="{
                key: 'PROFILE.MINOR_SELECTIONS.VALID',
                params: { validityPeriod: (selection.validityPeriod | localDateRange) },
                icon: 'open',
              }">
            </ng-container>
          </div>
          @if (!editMode && (selection.validityPeriod | dateRangePast)) {
            <div class="studymodule-notification">
              <ng-container
                [ngTemplateOutlet]="notification"
                [ngTemplateOutletContext]="{ key: 'PROFILE.MINOR_SELECTIONS.REQUEST_FOR_ENDED', icon: 'close' }">
              </ng-container>
            </div>
          }
          @if (selection.validityPeriod | dateRangePast) {
            <div class="studymodule-notification notification-continued">
              <ng-container
                [ngTemplateOutlet]="notification"
                [ngTemplateOutletContext]="{
                  key: 'PROFILE.MINOR_SELECTIONS.ENDED',
                  params: { endDate: (selection.validityPeriod.endDate | previousDay | localDateFormat) },
                }">
              </ng-container>
            </div>
          }
        </div>
      }

      @if (this.isRequestedMinorSelection) {
        <div class="studymodule-notification-bar">
          <div class="studymodule-notification">
            <ng-container
              [ngTemplateOutlet]="notification"
              [ngTemplateOutletContext]="{ key: 'PROFILE.MINOR_SELECTIONS.REQUESTED', icon: 'close' }">
            </ng-container>
          </div>
        </div>
      }
    </div>
  </sis-module-box>
</div>

<ng-template #notification let-key="key" let-params="params" let-icon="icon">
  <span class="studymodule-notification-content" [translate]="key" [translateParams]="params"></span>
  <span class="studymodule-notification-header">
    @if (icon) {
      <sis-icon [icon]="icon === 'open' ? 'lock-open' : 'lock'"></sis-icon>
    }
  </span>
</ng-template>
